// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__hV8As","buySell":"Tabs_buySell__mAVvU","tab":"Tabs_tab__1tbLm","sm":"Tabs_sm__eUU5g","activeTab":"Tabs_activeTab__JSuY-","type2":"Tabs_type2__ArPdW"};